import React from 'react';
const SVGcolor = '#E63946';
const size = '40';
export const Navigation = [
  {
    id: 1,
    title: 'About Us',
    link: '/about',
    subnav: [
      {
        id: 4,
        title: 'PACE Advantage',
        link: 'pace-advantage',
        isDirectLink: true,
      },
      {
        id: 2,
        title: 'Our Specialists',
        link: 'specialists',
        isDirectLink: true,
      },
      {
        id: 3,
        title: 'Careers',
        link: 'careers',
        isDirectLink: true,
      },
    ],
  },
  {
    id: 5,
    title: 'Our Services',
    link: '/services',
    subnav: [
      {
        id: 42,
        title: 'Arrhythmia Care',
        isDirectLink: true,
        link: 'arrhythmia-care',
      },
      {
        id: 30,
        title: 'Virtual Care',
        link: 'virtual-care',
        isDirectLink: true,
      },
      //       {
      //         id: 31,
      //         title: 'MyVIEW Mindfulness',
      //         link: 'myview-mindfulness',
      //       },
      {
        id: 32,
        title: 'Electrocardiography',
        link: 'electrocardiography',
      },
      {
        id: 33,
        title: 'Exercise Stress Testing',
        link: 'exercise-stress-testing',
      },
      {
        id: 34,
        title: 'Echocardiography',
        link: 'echocardiography',
      },
      {
        id: 35,
        title: 'Stress Echocardiography',
        link: 'stress-echocardiography',
      },
      {
        id: 36,
        title: ' Holter Monitors (Traditional)',
        link: 'holter-monitors',
      },
      // need to check this link
      {
        id: 37,
        title: 'Holter Monitors (Smart Garment)',
        link: 'myant',
        isDirectLink: true,
      },
      {
        id: 38,
        title: 'Contrast Echocardiography',
        link: 'contrast-echocardiography',
      },
      {
        id: 39,
        title: 'Pediatric Cardiac Tests',
        link: 'pediatric-cardiac-tests',
      },
      {
        id: 40,
        title: 'Echocardiogram Bubble Study',
        link: 'echocardiogram-bubble-study',
      },
      {
        id: 41,
        title: 'Blood Pressure Monitors',
        link: 'blood-pressure-monitors',
      },
    ],
  },
  {
    id: 6,
    title: 'For Patients',
    link: '/patient-faq',
    subnav: [
      {
        id: 7,
        title: 'How to Book',
        link: 'how-to-book',
        isDirectLink: true,
      },
            {
        id: 8,
        title: 'Secure Texting',
        link: 'weltel',
        isDirectLink: true,
      },
      {
        id: 9,
        title: 'Educational Videos',
        link: 'educational-videos',
        isDirectLink: true,
      },
      // {
      //   id: 10,
      //   title: 'At Home ECGs',
      //   link: 'ecgs',
      //   isDirectLink: true,
      // },
      {
        id: 19,
        title: 'Patient FAQ',
        link: 'patient-faq',
        isDirectLink: true,
      },
      {
        id: 421,
        title: 'Ocean e-Referrals',
        link: 'patient-oceanreferral',
        isDirectLink: true,
      },
      {
        id: 426,
        title: 'Patient Survey',
        link: '/pace-cardiology-patient-survey.pdf',
        pdf: true,
      },
            {
        id: 450,
        title: 'Privacy at PACE',
        link: 'privacy',
        isDirectLink: true,
      },
      // {
      //   id: 427,
      //   title: 'Covid-19 Cardiology Care',
      //   link: 'cardiology-care',
      //   isDirectLink: true,
      // },
    ],
  },
  {
    id: 11,
    title: 'For Clinics',
    link: '#',
    subnav: [
      {
        id: 12,
        title: 'Referrals',
        link: 'referrals',
        isDirectLink: true,
      },
      {
        id: 420,
        title: 'Healthcare Providers FAQ',
        link: 'provider-faq',
        isDirectLink: true,
      },
      {
        id: 424,
        title: 'Ocean e-Referrals',
        link: 'healthcare-oceanreferral',
        isDirectLink: true,
      },
      {
        id: 427,
        title: 'Provider Survey',
        link: '/pace-cardiology-hp-survey.pdf',
        pdf: true,
      },
    ],
  },
  {
    id: 17,
    title: 'Wellness',
    link: '#',
    subnav: [
      {
        id: 430,
        title: 'MyVIEW One-on-One Services',
        link:
          'https://myview-cardiac-wellness-program.myshopify.com/collections/virtual-one-on-one-services',
        isDirectLink: true,
      },
      {
        id: 431,
        title: 'MyVIEW AFib Life Program',
        link: 'https://my-view.ca/afib-life/',
        isDirectLink: true,
      },
      // {
      //   id: 432,
      //   title: 'MyVIEW Cardiac Wellness Program',
      //   link: 'https://my-view.ca/cardiac-wellness/',
      //   isDirectLink: true,
      // },
      // {
      //   id: 433,
      //   title: 'MyVIEW Mindfulness',
      //   link: 'https://my-view.ca/mindfulness/',
      //   isDirectLink: true,
      // },
      {
        id: 434,
        title: 'Ideal Protein Weight Loss',
        link: 'https://paceweightloss.com/',
      },
    ],
  },
  {
    id: 13,
    title: 'Research',
    link: '#',
    subnav: [
      {
        id: 428,
        title: 'Cardiac Medications',
        link: 'research',
        isDirectLink: true,
      },
    ],
  },
  {
    id: 14,
    title: 'Conditions/ Treatments',
    link: '/conditions-treatments',
    subnav: [],
  },
  // {
  //   id: 15,
  //   title: 'Virtual Care',
  //   link: '/virtual-care',
  //   subnav: [],
  // },
  {
    id: 16,
    title: 'Contact Us',
    link: '/contact',
    subnav: [],
  },
  {
    id: 18,
    title: 'Referral Forms',
    link: '#',
    isButton: true,
    subnav: [
      {
        id: 20,
        title: 'Online Clinic Referral Form',
        link: 'https://afcompanion.com/PacePatientReferralForm.html',
        isDirectLink: true,
      },
      {
        id: 21,
        title: 'Clinic Referral Form PDF',
        link: 'https://pace-cardiology.com/pace-patient-referral-form.pdf',
        isDirectLink: true,
      },
      {
        id: 22,
        title: 'Online Orillia Echo Clinic Form',
        link: 'https://afcompanion.com/PaceCardiologyOrilliaReferralForm.html',
        isDirectLink: true,
      },
      {
        id: 23,
        title: 'Orillia Echo Clinic Form PDF',
        link: 'https://pace-cardiology.com/pace-cardiology-orillia-referral-form-2023.pdf',
        isDirectLink: true,
      },
      {
        id: 24,
        title: 'Online AFib Self Referral Form',
        link: 'https://afcompanion.com/pacecardiologynewpatientform.html',
        isDirectLink: true,
      },
      {
        id: 25,
        title: 'OceanMD eReferral',
        link: 'https://www.oceanmd.com/getting-started/ontario-ereferral-signup/',
        isDirectLink: true,
      },
    ],
  },
];
export const Social = [
  {
    id: 1,
    name: 'Facebook',
    href: 'https://www.facebook.com/PACECardiologyClinics/',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-brand-facebook"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke={SVGcolor}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
      </svg>
    ),
  },
  {
    id: 2,
    name: 'Instagram',
    href: 'https://www.instagram.com/pacecardiology/?hl=en',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-brand-instagram"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke={SVGcolor}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <rect x="4" y="4" width="16" height="16" rx="4" />
        <circle cx="12" cy="12" r="3" />
        <line x1="16.5" y1="7.5" x2="16.5" y2="7.501" />
      </svg>
    ),
  },
  {
    id: 3,
    name: 'Twitter',
    href: 'https://twitter.com/pace_cardiology?lang=en',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-brand-twitter"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke={SVGcolor}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.302 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z" />
      </svg>
    ),
  },
  {
    id: 4,
    name: 'YouTube',
    href: 'https://www.youtube.com/channel/UCAxAy436opHSzll5TKggOBQ',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-brand-youtube"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke={SVGcolor}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <rect x="3" y="5" width="18" height="14" rx="4" />
        <path d="M10 9l5 3l-5 3z" />
      </svg>
    ),
  },
  {
    id: 5,
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/pace-cardiology',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-brand-linkedin"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke={SVGcolor}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <rect x="4" y="4" width="16" height="16" rx="2" />
        <line x1="8" y1="11" x2="8" y2="16" />
        <line x1="8" y1="8" x2="8" y2="8.01" />
        <line x1="12" y1="16" x2="12" y2="11" />
        <path d="M16 16v-3a2 2 0 0 0 -4 0" />
      </svg>
    ),
  },
];
